<template>
  <div class="formContent">
    <div class="tabChage">
      <div>
        <el-select
          v-model="radio"
          size="mini"
          value-key="key"
          @change="getDataValue"
        >
          <el-option
            v-for="v in dateList"
            :label="v.name"
            :value="v"
            :key="v.key"
            size="mini"
          ></el-option>
        </el-select>
        <el-date-picker
          v-if="radio.value != 'UNLIMITED'"
          v-model="dateValue"
          size="mini"
          :clearable="false"
          :type="radio.key"
          :key="radio.key"
          :placeholder="radio.tip"
          :value-format="
            radio.value === 'HOUR' ? 'yyyy-MM-dd HH' : radio.format
          "
          style="margin-left: 20px"
        >
        </el-date-picker>
        <el-button
          type="primary"
          @click="exportData"
          size="mini"
          style="margin-left: 20px"
          ><i class="el-icon-refresh el-icon--left"></i>导入数据</el-button
        >
        <el-button
          type="primary"
          size="mini"
          style="margin-left: 20px"
          @click="showCharts"
          >分析图</el-button
        >
      </div>
      <div v-if="showDownload">
        <el-button
          type="primary"
          v-if="$route.path == '/customReport'"
          @click="addForm"
          size="mini"
          style="margin-right: 10px"
          ><i class="el-icon-download el-icon--left"></i
          >保存为模板并导出</el-button
        >
        <el-button
          type="primary"
          @click="exportExcel('')"
          size="mini"
          style="margin-right: 20px"
          ><i class="el-icon-download el-icon--left"></i>导出</el-button
        >
      </div>
    </div>
    <div class="fromBox">
      <el-table
        :data="tableList"
        :key="dynamicsIndex"
        ref="table"
        height="100%"
        stripe
        style="width: 100%"
        :header-cell-style="{
          color: '#333',
          'background-color': '#F7F7F7',
        }"
        size="mini"
      >
        <el-table-column
          prop="time"
          v-if="tabHead.length"
          label="时间"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-for="(v, i) in tabHead"
          :key="i"
          :prop="v.prop"
          :label="v.label"
          align="center"
          :formatter="$setTabNumber"
        >
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="分析图"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="20%;"
    >
      <div style="width: 90%; height: 300px">
        <PublicEcharts
          id="'myCharts'"
          :chartsData="chartsData"
          :type="'lightLine'"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import PublicEcharts from "@/components/PublicEcharts";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
    showDownload: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    PublicEcharts,
  },
  data() {
    return {
      jsonList: require("@/assets/json/telemetry.json").data,
      dateList: [
        {
          name: "小时",
          value: "HOUR",
          key: "datetime",
          tip: "选择日期",
          format: "yyyy-MM-dd hh",
          showTime: "hh:mm:ss",
        },
        {
          name: "日",
          value: "DAY",
          key: "date",
          tip: "选择日期",
          format: "yyyy-MM-dd",
          showTime: "hh:mm:ss",
        },
        {
          name: "月",
          value: "MONTH",
          key: "month",
          tip: "选择月",
          format: "yyyy-MM",
          showTime: "MM月dd日",
        },
        {
          name: "年",
          value: "YEAR",
          key: "year",
          tip: "选择年",
          format: "yyyy",
          showTime: "yyyy年MM月",
        },
        {
          name: "总计",
          value: "UNLIMITED",
          showTime: "yyyy年",
        },
      ],
      radio: {},
      dateValue: "",
      tableList: [],
      tabHead: [],
      dialogVisible: false,
      chartsData: { title: "", unit: "", xData: [], dataArr: [] },
      itemObj: {},
      dynamicsIndex: 0,
    };
  },
  watch: {
    activeItem(val) {
      // console.log(val);
      this.itemObj = this.jsonList.find((v) => {
        return v.key == val.key;
      });
      this.tabHead = [];
      if (val.ydata && val.ydata.length) {
        val.ydata.map((v) => {
          this.tabHead.push({ label: v.dis_name, prop: v.dis_name });
        });
      }
      this.tableList = [];
    },
  },
  methods: {
    async exportData() {
      this.tableList = [];
      if (this.tabHead.length == 0) {
        this.$message.error("未设置查询条件!");
        return false;
      }
      if (
        (this.radio.value == "DAY" || this.radio.value == "HOUR") &&
        this.activeItem.ydata.length > 10
      ) {
        this.$message.error("时间范围选择小时或者天，最多可查询十条资产");
        return;
      }
      this.$store.commit("SET_LOADING", true);
      let res = await api.formGetTabData({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        x_type: this.radio.value,
        x_data: this.dateValue,
        key: this.activeItem.key,
        y_data: JSON.stringify(this.activeItem.ydata),
      });
      this.dynamicsIndex++;
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableList = res.data.data;
        this.tableList.map((v) => {
          v.time = dateFtt(this.radio.showTime, new Date(v.ts));
        });
      } else {
        this.$store.commit("SET_LOADING", false);
      }
    },
    showCharts() {
      this.dialogVisible = true;
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.chartsData.unit = this.itemObj.unit;
      setTimeout(() => {
        this.tabHead.map((v) => {
          this.chartsData.dataArr.push({ name: v.prop, data: [] });
        });
        this.tableList.map((v) => {
          this.chartsData.xData.push(v.time);
          for (let key in v) {
            let index = this.chartsData.dataArr.findIndex((v) => {
              return v.name == key;
            });
            if (index >= 0) {
              this.chartsData.dataArr[index].data.push(v[key]);
            }
          }
        });
      }, 20);
    },
    addForm() {
      if (this.tableList.length == 0) {
        this.$message.error("没有可存储的模板!");
        return false;
      }
      let addFormItem = {
        xtype: this.radio.value,
        xdata: this.dateValue,
        ydata: this.activeItem.ydata,
        key: this.activeItem.key,
      };
      this.$emit("openAddForm", addFormItem);
    },
    getDataValue() {
      this.dateValue =
        this.radio.value != "UNLIMITED"
          ? dateFtt(this.radio.format, new Date())
          : null;
    },
    exportExcel(name) {
      let excelTitle = this.activeItem.name
        ? this.activeItem.name
        : name
        ? name
        : `${this.dateValue ?? "全部"}-${this.itemObj.name}`;
      if (this.tableList.length == 0) {
        this.$message.error("没有可导出的数据!");
        return false;
      }
      let th = [];
      let tabHeader = [{ label: "时间", prop: "time" }].concat(this.tabHead);
      tabHeader.map((v) => {
        th.push(v.label);
      });
      let content = [];
      this.tableList.map((v) => {
        let row = [];
        tabHeader.map((item) => {
          row.push(v[item.prop]);
        });
        content.push(row);
      });
      exportFile.xlsxFile(XLSX, excelTitle, {
        excel: [th, ...content],
      });
    },
  },
  created() {
    this.radio = this.dateList[1];
    this.getDataValue();
  },
};
</script>

<style lang="scss" scoped>
.formContent {
  width: 100%;
  height: 100%;

  .tabChage {
    height: 65px;
    margin-left: 20px;
    @include setFlexBetween;
  }

  .fromBox {
    height: calc(100% - 70px);
    width: 97%;
    margin: 0 auto;
  }
}
</style>
